<p-dialog #addUserDialog [contentStyle]="{'max-height':'85vh'}" [focusOnShow]="false" width="800" minHeight="600"
    [closable]="false" [blockScroll]="true" [modal]="true" [draggable]="false" [baseZIndex]="500"
    header="Short Code Transfer" [(visible)]="display" (onHide)="cancel()">
    <!-- <div class="w-450px">
        <iui-messages #message  class="ms-auto me-auto"></iui-messages>
    </div> -->
    <div *ngIf="isWarningVisible" class="alert-success wanning-pannel">
        <div>
         <b>Attention</b>   
        </div>
        <div >
            <ul>
                <li>
                    The short code will be scheduled to auto-renew and your account's default credit card will be charged once
            the transfer is complete. Please ensure that the default credit card information on your account is correct.
                </li>
            </ul>
           
        </div>
    </div>
    <form #transferForm="ngForm">
        <div class="mb-2 ms-3 me-5">
            <div class="row mb-2">
                <div class="col-12">
                    {{fromCompany}} wishes to transfer a short code, {{scId}}, to your account.
                </div>
                <div class="col-12 mt-2">
                    To accept this short code transfer, click Accept. Customer Support may contact you
                    for more information before this transfer is finalized.
                </div>
                <div class="col-12 mt-2">
                    To decline this short code transfer, click Decline.
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-12 ">
                    <label for='prepayId' class="required fw-bold">Transfer Type:</label>
                </div>
            </div>
            <div>
                <div class="row ms-0 mb-2">
                    <p-radioButton name="prepay" id="prepayId" [(ngModel)]="prepayValue" (onClick)="hideWarning()"
                    value="1" label="Prepay"
                  ></p-radioButton>
                </div>
                <div class="row  ms-0 mb-2" *ngIf="leaseStatus==='Approved' || leaseStatus==='PendingRenew' || leaseStatus==='Cancelled'">
                    <p-radioButton name="prepayValue" id="prepayOptinId" [(ngModel)]="prepayValue" (onClick)="displayWarning()"
                        value="2" [label]="prepayRadioLabel"></p-radioButton>
                </div>
                <div class="row  ms-0 mb-3" *ngIf="isMonthlyBillingEnabled">
                    <p-radioButton name="prepayValue" id="monthlyId" [(ngModel)]="prepayValue" (onClick)="hideWarning()"
                        value="3" checked label="Monthly Billing"></p-radioButton>
                </div>
            </div>
            <div class="mt-4">
                <div class="row ms-0 mb-1">
                    <label for='termAgreement' class="required fw-bold">Terms & Conditions:</label>
                </div>
                <div class="row ms-0 ">
                    
                    <p-checkbox name="termAgreement" id="termAgreement" [(ngModel)]="transferAgreement"
                        [required]="true" [binary]="true" [binary]="true" #termAgreementCheckbox="ngModel" 
                        label="I have read and accept the Short Code Transfer Terms & Conditions."> </p-checkbox>
                </div>

                <div class="error-msg" *ngIf="termAgreementCheckbox.errors && termAgreementCheckbox.touched">
                    <span class="failed">
                        Please select the transfer acceptance checkbox.
                    </span>
                </div>


                <div class="row ms-0">
                    <!-- <div class="error-msg" *ngIf="transferAgreement.invalid">
                    <span class="failed">
                      Please read the Registrant Sublicense Agreements and click on the box to accept.
                    </span>
                  </div> -->
                    <div class="row  term-align">
                       <span> As a representative of the organization receiving the short code, I hereby request, and accept,
                        the transfer of the short code {{scId}} into my account from Account No. {{fromAccountID}}. 
                        I understand that iconectiv, as the registry service provider for short codes, will effectuate 
                        the transfer as promptly as commercially possible after receipt of authorization from both the 
                        Releasing Organization and the Receiving Organization. I understand that by accepting this
                        short code transfer, my account accepts all terms and conditions defined in the User 
                        Sublicense Agreement as pertains to this code and its associated campaign(s) and content
                        and assume any responsibility for any outstanding and unpaid fees associated with this code. I
                        understand that if this code was pre-paid by the Releasing Party, neither the CTIA nor 
                        iconectiv is responsible for furnishing any reimbursement for any remaining portion of the
                        lease term for such code to either the Releasing or the Receiving Parties. In this case, the term
                        of the lease and the expiration date remain unchanged. I further understand that if this code is
                        enrolled in monthly billing,
                        my account assumes responsibility for payment of the ongoing monthly payments. In this case,
                        upon transfer, the term of the lease is reset (to 12 months if transferring from monthly billing
                        to monthly billing;
                        or to 3 months if transferring from monthly billing to prepay) and the expiration date is reset
                        as appropriate. I also understand that, because this short code will be enrolled in monthly
                        billing, there may be limitations regarding when I can opt out of Auto-Renewal. Additionally,
                        for the case of monthly billing and the case of prepay, opt-in to auto-renew, I understand and
                        agree that by checking this box,
                        I authorize the Short Code Registry to charge to my card the applicable fee for renewal of this
                        code for identical lease periods
                        on an ongoing basis up and until I explicitly opt-out of Auto-Renewal for this code. I further
                        understand and agree that each
                        renewal shall be subject to the terms and conditions of Short Code Auto-Renew as described in
                        the &nbsp;<a [href]="licenseAgreementcontent" target="_blank">Short
                            Code Registry's Registrant Sublicense Agreement</a>&nbsp; (last updated {{licenseAgreementDate}}) and &nbsp;
                            <a [href]="bestPracticesContent" target="_blank">
                                Messaging Principles and Best Practices
                            </a>&nbsp; (last updated {{bestPracticesDate}}).</span>
                    </div>
                   
                </div>
            </div>
        </div>

    </form>
    <p-footer>
        <div class="d-flex justify-content-end me-2">
            <button i18n id="scaccept" class="btn btn-primary me-2" type="button" *ngIf="transferStatus!=='Accepted'"
                (click)="acceptTransfer(transferForm)">Accept</button>
            <button i18n id="scReject" class="btn btn-primary me-2" type="button"
                (click)="declineTransfer()">Decline</button>
            <button i18n id="screject" class="btn btn-secondary" type="button" (click)="closeDialog()">Cancel</button>
        </div>
    </p-footer>
</p-dialog>